/**
 * AuditCategoryBadge (#1119 Slice 3) — the shared category pill for both
 * audit surfaces. Pass `categoryKey` (customer rows carry a server-
 * projected category) or `action` (admin rows carry the raw action key).
 */
import { categoryForAction, categoryMetaByKey } from '@/lib/auditCategories'

export function AuditCategoryBadge({
  action,
  categoryKey,
}: {
  action?: string
  categoryKey?: string
}) {
  const meta = action !== undefined ? categoryForAction(action) : categoryMetaByKey(categoryKey ?? 'other')
  return (
    <span
      className={`inline-block whitespace-nowrap rounded px-1.5 py-0.5 text-[10px] font-semibold ${meta.className}`}
    >
      {meta.label}
    </span>
  )
}
